<template>
  <div class="bonus-table">
    <div class="bonus-table__inner">
      <div class="bonus-table__head">
        <div class="bonus-table__head-col">Дата</div>
        <div class="bonus-table__head-col">Начисление</div>
        <div class="bonus-table__head-col">Списание</div>
        <div class="bonus-table__head-col">Заказ</div>
        <div class="bonus-table__head-col">Поставщик</div>
      </div>
      <div class="bonus-table__body" v-if="list.length">
        <div class="bonus-table__row" v-for="item in list" :key="item.id">
          <div class="bonus-table__row-col bonus-table__date">
            {{ item.date }}
          </div>
          <div class="bonus-table__row-col">
            <div
              class="bonus-table__price is-success"
              v-if="item.transactionType === 'deposit'"
            >
              + {{ item.amount | price() }}
            </div>
            <div v-else class="bonus-table__price">-</div>
          </div>
          <div class="bonus-table__row-col">
            <div
              class="bonus-table__price is-danger"
              v-if="item.transactionType === 'withdrawal'"
            >
              - {{ item.amount | price() }}
            </div>
            <div v-else class="bonus-table__price">-</div>
          </div>
          <div class="bonus-table__row-col">
            <router-link :to="`/orders/item/${item.orderNumber}`">{{
              item.orderNumber
            }}</router-link>
          </div>
          <div class="bonus-table__row-col">
            {{ item.sellerContractor.name }}
          </div>
        </div>
      </div>
      <div v-else class="bonus-table__empty">Нет записей</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BonusTable',
  inject: ['responsive'],
  components: {},
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.bonus-table {
  display: flex;
  overflow-x: auto;
  background: #fff;

  &__inner {
    flex-grow: 1;
    min-width: 600px;
  }

  &__date {
    white-space: nowrap;
    opacity: 0.5;
  }

  &__price {
    font-weight: 600;
    white-space: nowrap;

    &.is-success {
      color: #2bca6d;
    }

    &.is-danger {
      color: #f10039;
    }
  }

  a {
    color: #000;
  }

  &__head {
    display: flex;
    border-bottom: solid 1px #e9e9e9;
    gap: 15px;

    &-col {
      display: flex;
      align-items: center;
      width: 100%;
      min-width: 0;
      min-height: 50px;
      font-size: 14px;
      font-weight: 300;

      &:first-child {
        padding-left: 20px;
      }

      &:last-child {
        padding-right: 20px;
      }
    }
  }

  &__row {
    display: flex;
    border-bottom: solid 1px #e9e9e9;
    gap: 15px;

    &-col {
      width: 100%;
      min-width: 0;
      padding-top: 15px;
      padding-bottom: 15px;
      font-size: 14px;
      font-weight: 300;
      line-height: 1.2;

      @include media-xs() {
        font-size: 12px;
      }

      &:first-child {
        padding-left: 20px;
      }

      &:last-child {
        padding-right: 20px;
      }
    }
  }

  &__empty {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
